// api should be here
import { http } from '@/utils/http';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getNewsList = (params: any) => {
  return http.get(`/v1/news/topicList`, {
    params,
  });
};
const getNewstpList = (params: any) => {
  return http.get(`/v1/news/topicSpecialList`, {
    params,
  });
};
const urlPrefix = '/vote/2023project/q3/2023zghome/controller.php?enews=';

const getShowList = () => {
  return http.get(`${urlPrefix}show-list`);
};

const getNewsDetail = (classid: any, newsid: any) => {
  return http.get(`https://newsapi.cqcb.com/v1/detail?columnId=${classid}&newsId=${newsid}`);
};
export { getNewsList,getNewsDetail, getShowList, getBaseInfo, getNewstpList };
